var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHacksawSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.999 511.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M225.493,146.186L14.379,357.299c-19.172,19.161-19.172,50.357,0,69.519l55.167,55.156 c8.974,8.974,24.245,5.043,27.833-7.051l12.535-42.153l51.75-4.712c6.811-0.621,12.557-5.332,14.505-11.882l12.535-42.164 l51.74-4.701c6.811-0.621,12.557-5.332,14.505-11.882l12.546-42.164l51.74-4.712c6.811-0.621,12.557-5.332,14.505-11.882 l10.146-34.096L225.493,146.186z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M497.298,134.369l-94.533-94.544c-19.59-19.59-51.322-19.612-70.912,0l-70.912,70.912c-6.528,6.528-6.528,17.105,0,23.634 l118.178,118.178c19.534,19.556,51.353,19.558,70.912,0l47.267-47.267C516.888,185.691,516.911,153.959,497.298,134.369z  M426.399,181.636c-6.529,6.528-17.104,6.528-23.634,0l-47.278-47.267c-6.528-6.528-6.528-17.105,0-23.634 c6.528-6.528,17.105-6.528,23.634,0l47.278,47.267C432.928,164.532,432.928,175.108,426.399,181.636z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHacksawSvg);
export default __webpack_public_path__ + "static/media/hacksaw-svg.619f35d89bf67c535f6c8cc45ea9198a.svg";
export { ForwardRef as ReactComponent };